// extracted by mini-css-extract-plugin
export default {"arrowLeft":"Pagination_arrowLeft__6CLaP","arrowRight":"Pagination_arrowRight__DKUIS","paginator":"Pagination_paginator__jIBrp"};